import { z } from "zod";

/**
 * SSE events for the project chat stream.
 * Discriminated union by `type` field.
 */
export const chatStreamEventSchema = z.discriminatedUnion("type", [
  /** Incremental thinking/reasoning from extended thinking. */
  z.object({
    type: z.literal("thinking_delta"),
    content: z.string(),
  }),
  /** Incremental text from the assistant response. */
  z.object({
    type: z.literal("message_delta"),
    content: z.string(),
  }),
  /** The LLM is invoking a tool (KB search, web search). */
  z.object({
    type: z.literal("tool_call"),
    tool: z.string(),
    query: z.string(),
  }),
  /** Tool execution completed with results. */
  z.object({
    type: z.literal("tool_result"),
    tool: z.string(),
    resultCount: z.number(),
  }),
  /** Full response is complete. Includes the persisted message ID and citations. */
  z.object({
    type: z.literal("message_complete"),
    messageId: z.string(),
    threadId: z.string(),
    citations: z.array(
      z.object({
        sourceId: z.string(),
        sourceName: z.string(),
        authorityLevel: z.string(),
        snippet: z.string(),
      }),
    ),
  }),
  /** An entity proposed by the LLM for user review. */
  z.object({
    type: z.literal("entity_proposal"),
    entityType: z.enum(["persona", "scenario", "source"]),
    data: z.record(z.string(), z.unknown()),
    suggestedActions: z.array(
      z.object({ label: z.string(), action: z.string() }),
    ),
  }),
  /** Stream-level error. */
  z.object({
    type: z.literal("error"),
    message: z.string(),
  }),
]);

export type ChatStreamEvent = z.infer<typeof chatStreamEventSchema>;
